const FETCH_ADJUSTMENTS_REQUEST = 'FETCH_ADJUSTMENTS_REQUEST';
const FETCH_ADJUSTMENTS_SUCCESS = 'FETCH_ADJUSTMENTS_SUCCESS';
const FETCH_ADJUSTMENTS_ERROR = 'FETCH_ADJUSTMENTS_ERROR';
const HIDE_ADJUSTMENT_LOADER = 'HIDE_ADJUSTMENT_LOADER';
const SHOW_ADJUSTMENT_LOADER = 'SHOW_ADJUSTMENT_LOADER';
const GENERATE_ADJUSTMENT_REPORT_REQUEST = 'GENERATE_ADJUSTMENT_REPORT_REQUEST';
const GENERATE_ADJUSTMENT_REPORT_SUCCESS = 'GENERATE_ADJUSTMENT_REPORT_SUCCESS';
const GENERATE_ADJUSTMENT_REPORT_ERROR = 'GENERATE_ADJUSTMENT_REPORT_ERROR';
const GET_ACTIVE_ADJUSTMENT_REPORT_REQUEST =
    'GET_ACTIVE_ADJUSTMENT_REPORT_REQUEST';
const GET_ACTIVE_ADJUSTMENT_REPORT_SUCCESS =
    'GET_ACTIVE_ADJUSTMENT_REPORT_SUCCESS';
const GET_ACTIVE_ADJUSTMENT_REPORT_ERROR = 'GET_ACTIVE_ADJUSTMENT_REPORT_ERROR';
const DOWNLOAD_ADJUSTMENT_REPORT_REQUEST = 'DOWNLOAD_ADJUSTMENT_REPORT_REQUEST';
const DOWNLOAD_ADJUSTMENT_REPORT_SUCCESS = 'DOWNLOAD_ADJUSTMENT_REPORT_SUCCESS';
const DOWNLOAD_ADJUSTMENT_REPORT_ERROR = 'DOWNLOAD_ADJUSTMENT_REPORT_ERROR';
const RESET_ADJUSTMENT_STATE = 'RESET_ADJUSTMENT_STATE';
const CREATE_ADJUSTMENT_REQUEST = 'CREATE_ADJUSTMENT_REQUEST';
const CREATE_ADJUSTMENT_SUCCESS = 'CREATE_ADJUSTMENT_SUCCESS';
const CREATE_ADJUSTMENT_ERROR = 'CREATE_ADJUSTMENT_ERROR';
const CREATE_ADJUSTMENT_RESET = 'CREATE_ADJUSTMENT_RESET';

export {
    FETCH_ADJUSTMENTS_REQUEST,
    FETCH_ADJUSTMENTS_SUCCESS,
    FETCH_ADJUSTMENTS_ERROR,
    HIDE_ADJUSTMENT_LOADER,
    SHOW_ADJUSTMENT_LOADER,
    GENERATE_ADJUSTMENT_REPORT_REQUEST,
    GENERATE_ADJUSTMENT_REPORT_SUCCESS,
    GENERATE_ADJUSTMENT_REPORT_ERROR,
    GET_ACTIVE_ADJUSTMENT_REPORT_REQUEST,
    GET_ACTIVE_ADJUSTMENT_REPORT_SUCCESS,
    GET_ACTIVE_ADJUSTMENT_REPORT_ERROR,
    DOWNLOAD_ADJUSTMENT_REPORT_REQUEST,
    DOWNLOAD_ADJUSTMENT_REPORT_SUCCESS,
    DOWNLOAD_ADJUSTMENT_REPORT_ERROR,
    RESET_ADJUSTMENT_STATE,
    CREATE_ADJUSTMENT_REQUEST,
    CREATE_ADJUSTMENT_SUCCESS,
    CREATE_ADJUSTMENT_ERROR,
    CREATE_ADJUSTMENT_RESET,
};
